import { Vorbelegungdaten, Vorvertrag } from '@ps20-frontend/frontend-models';
import { AngebotsId } from '@ps20-frontend/shop-integration-redux';
import { WarenkorbAngebot } from '../produkte.reducer';

export function findVorvertrageForAngebot(
  warenkorbAngebot: WarenkorbAngebot,
  vorvertraege: Vorvertrag[],
): Vorvertrag[] {
  return vorvertraege.filter(vorvertrag =>
    warenkorbAngebot.vorvertragsNummern.some(
      nummer =>
        nummer.vertragsnummer === vorvertrag.vertragsnummer &&
        nummer.spLaufnummer === vorvertrag.spLaufnummer,
    ),
  );
}

export function getVorbelegungdaten(
  angebotsId: AngebotsId,
  vorvertrag: Vorvertrag,
): Vorbelegungdaten {
  return vorvertrag
    ? vorvertrag.vorbelegungdaten.find(
        daten => daten.angebotsId === angebotsId.angebotsId && daten.forApp === angebotsId.appId,
      )
    : null;
}
